import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { AuthContext } from './AuthContext';
import api from '../services/api';

export const ModuleContext = createContext({ modules: [], loading: true, hasModule: () => true, reloadModules: () => {} });

export function ModuleProvider({ children }) {
  const { token } = useContext(AuthContext);
  const [modules, setModules] = useState([]);
  const [loading, setLoading] = useState(Boolean(token));

  const reloadModules = useCallback(async () => {
    if (!token) { setModules([]); setLoading(false); return; }
    setLoading(true);
    try {
      const { data } = await api.get('/tenants/me/modulos');
      setModules(Array.isArray(data?.modulos) ? data.modulos : []);
    } catch { setModules([]); }
    finally { setLoading(false); }
  }, [token]);

  useEffect(() => { reloadModules(); }, [reloadModules]);
  const value = useMemo(() => ({ modules, loading, hasModule: (id) => modules.includes(id), reloadModules }), [modules, loading, reloadModules]);
  return <ModuleContext.Provider value={value}>{children}</ModuleContext.Provider>;
}

export const useModules = () => useContext(ModuleContext);
